import { render } from "./SmallCopyIcon.vue?vue&type=template&id=5fc4edf3&ts=true"
import script from "./SmallCopyIcon.vue?vue&type=script&lang=ts"
export * from "./SmallCopyIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__